import { createService } from "./service"
export { PUBLIC_HOSTS, PUBLIC_HOSTS_KEYS } from './constant'

export const service = createService()

// 工具函数
export const getOrigin = (...args: Parameters<typeof service.getOrigin>) =>
  service.getOrigin(...args)
export const getHost = (...args: Parameters<typeof service.getHost>) =>
  service.getHost(...args)
export const getPath = (...args: Parameters<typeof service.getPath>) =>
  service.getPath(...args)
export const getScheme = (...args: Parameters<typeof service.getScheme>) =>
  service.getScheme(...args)
export const getPort = (...args: Parameters<typeof service.getPort>) =>
  service.getPort(...args)
export const getServiceConf = (...args: Parameters<typeof service.getServiceConf>) =>
  service.getServiceConf(...args)
export const getKdocsPath = (...args: Parameters<typeof service.getKdocsPath>) =>
  service.getKdocsPath(...args)
export const replaceOpenHref = (...args: Parameters<typeof service.replaceOpenHref>) =>
  service.replaceOpenHref(...args)
export const replaceLocHost = (...args: Parameters<typeof service.replaceLocHost>) =>
  service.replaceLocHost(...args)

export { hostHooks } from "./util/hostMrg"
export { createService } from "./service"
export { REAL_KDOCS_HOSTS, isCustomDomain } from "./service/public"

// 勿删下边的注释，这是一个占位符
export const ACCOUNT: string = getOrigin('ACCOUNT')

  export const ACCOUNTKDOCS: string = getOrigin('ACCOUNTKDOCS')

  export const APIWPS: string = getOrigin('APIWPS')

  export const APKDOCS: string = getOrigin('APKDOCS')

  export const AVATAR: string = getOrigin('AVATAR')

  export const CONTACT: string = getOrigin('CONTACT')

  export const CONTACTWPS: string = getOrigin('CONTACTWPS')

  export const CONTRACT: string = getOrigin('CONTRACT')

  export const COPILOT: string = getOrigin('COPILOT')

  export const DC: string = getOrigin('DC')

  export const DCKDOCS: string = getOrigin('DCKDOCS')

  export const DOC2HTML: string = getOrigin('DOC2HTML')

  export const DOCERAPI: string = getOrigin('DOCERAPI')

  export const DOCERHOME: string = getOrigin('DOCERHOME')

  export const DOCERKDOCS: string = getOrigin('DOCERKDOCS')

  export const DOCERMOWPS: string = getOrigin('DOCERMOWPS')

  export const DOCERVCLKDOCS: string = getOrigin('DOCERVCLKDOCS')

  export const DOCERWPS: string = getOrigin('DOCERWPS')

  export const DOCKERMOKDOCS: string = getOrigin('DOCKERMOKDOCS')

  export const DOCS: string = getOrigin('DOCS')

  export const DOCSERVER: string = getOrigin('DOCSERVER')

  export const DOCSK: string = getOrigin('DOCSK')

  export const DRIVE: string = getOrigin('DRIVE')

  export const DWEBMODOU: string = getOrigin('DWEBMODOU')

  export const DYNAMICEDU: string = getOrigin('DYNAMICEDU')

  export const ECIS: string = getOrigin('ECIS')

  export const EDU: string = getOrigin('EDU')

  export const EDUDOCS: string = getOrigin('EDUDOCS')

  export const EDUKDOCS: string = getOrigin('EDUKDOCS')

  export const FACE: string = getOrigin('FACE')

  export const FACEAPI: string = getOrigin('FACEAPI')

  export const FACEAPIWPS: string = getOrigin('FACEAPIWPS')

  export const FACEWPS: string = getOrigin('FACEWPS')

  export const FEEDBACKWPS: string = getOrigin('FEEDBACKWPS')

  export const FILECOLLECT: string = getOrigin('FILECOLLECT')

  export const FILEOPERATE: string = getOrigin('FILEOPERATE')

  export const FORM: string = getOrigin('FORM')

  export const FORMAPI: string = getOrigin('FORMAPI')

  export const GEOACCOUNT: string = getOrigin('GEOACCOUNT')

  export const HD: string = getOrigin('HD')

  export const IMAGE: string = getOrigin('IMAGE')

  export const IMAGEBUCKET: string = getOrigin('IMAGEBUCKET')

  export const IMG: string = getOrigin('IMG')

  export const JUMP: string = getOrigin('JUMP')

  export const KDOC: string = getOrigin('KDOC')

  export const KDOCS: string = getOrigin('KDOCS')

  export const KDOCSCN: string = getOrigin('KDOCSCN')

  export const KDOCSFIXED: string = getOrigin('KDOCSFIXED')

  export const KDOCSOM: string = getOrigin('KDOCSOM')

  export const KDOCSVCL: string = getOrigin('KDOCSVCL')

  export const KOA: string = getOrigin('KOA')

  export const MEETING: string = getOrigin('MEETING')

  export const MOWEB: string = getOrigin('MOWEB')

  export const MSGCENTER: string = getOrigin('MSGCENTER')

  export const MSGEVENT: string = getOrigin('MSGEVENT')

  export const NOTE: string = getOrigin('NOTE')

  export const NOTEAPI: string = getOrigin('NOTEAPI')

  export const OPEN: string = getOrigin('OPEN')

  export const OPENAPI: string = getOrigin('OPENAPI')

  export const PAN: string = getOrigin('PAN')

  export const PAYAPI: string = getOrigin('PAYAPI')

  export const PAYCONFIGAPI: string = getOrigin('PAYCONFIGAPI')

  export const PC: string = getOrigin('PC')

  export const PLUS: string = getOrigin('PLUS')

  export const PLUSKDOCS: string = getOrigin('PLUSKDOCS')

  export const PLUSSVR: string = getOrigin('PLUSSVR')

  export const PLUSSVRDOCS: string = getOrigin('PLUSSVRDOCS')

  export const PORTAL: string = getOrigin('PORTAL')

  export const PRIVACYWPS: string = getOrigin('PRIVACYWPS')

  export const PUB: string = getOrigin('PUB')

  export const PUBKDOCS: string = getOrigin('PUBKDOCS')

  export const PUBLISH: string = getOrigin('PUBLISH')

  export const PUBWPS: string = getOrigin('PUBWPS')

  export const RESUMEWEB: string = getOrigin('RESUMEWEB')

  export const RILI: string = getOrigin('RILI')

  export const RILIWPS: string = getOrigin('RILIWPS')

  export const SECURITYDOC: string = getOrigin('SECURITYDOC')

  export const STORE: string = getOrigin('STORE')

  export const TIANCE: string = getOrigin('TIANCE')

  export const TKDOCS: string = getOrigin('TKDOCS')

  export const TODO: string = getOrigin('TODO')

  export const TODOAPI: string = getOrigin('TODOAPI')

  export const TODOKDOCS: string = getOrigin('TODOKDOCS')

  export const TWPS: string = getOrigin('TWPS')

  export const VAS: string = getOrigin('VAS')

  export const VAS2T: string = getOrigin('VAS2T')

  export const VASKDOCS: string = getOrigin('VASKDOCS')

  export const VIP: string = getOrigin('VIP')

  export const VIPAPI: string = getOrigin('VIPAPI')

  export const VIPAPIKDOCS: string = getOrigin('VIPAPIKDOCS')

  export const VIPCASHDESK: string = getOrigin('VIPCASHDESK')

  export const VIPERSOPNAL: string = getOrigin('VIPERSOPNAL')

  export const VIPKDOCS: string = getOrigin('VIPKDOCS')

  export const WEBOFFICE: string = getOrigin('WEBOFFICE')

  export const WEBOFFICEPLUGIN: string = getOrigin('WEBOFFICEPLUGIN')

  export const WOA: string = getOrigin('WOA')

  export const WORK: string = getOrigin('WORK')

  export const WPS: string = getOrigin('WPS')

  export const WPS365: string = getOrigin('WPS365')

  export const WPSPAN: string = getOrigin('WPSPAN')

  export const WPSPLUS: string = getOrigin('WPSPLUS')

  export const WXBMC: string = getOrigin('WXBMC')

  export const YUNAPI: string = getOrigin('YUNAPI')

  export const YUNBIZ: string = getOrigin('YUNBIZ')

  export const ZTKDOCS: string = getOrigin('ZTKDOCS')

  export const hosts = {
    
      ACCOUNT: getHost('ACCOUNT') as string,
  
      ACCOUNTKDOCS: getHost('ACCOUNTKDOCS') as string,
  
      APIWPS: getHost('APIWPS') as string,
  
      APKDOCS: getHost('APKDOCS') as string,
  
      AVATAR: getHost('AVATAR') as string,
  
      CONTACT: getHost('CONTACT') as string,
  
      CONTACTWPS: getHost('CONTACTWPS') as string,
  
      CONTRACT: getHost('CONTRACT') as string,
  
      COPILOT: getHost('COPILOT') as string,
  
      DC: getHost('DC') as string,
  
      DCKDOCS: getHost('DCKDOCS') as string,
  
      DOC2HTML: getHost('DOC2HTML') as string,
  
      DOCERAPI: getHost('DOCERAPI') as string,
  
      DOCERHOME: getHost('DOCERHOME') as string,
  
      DOCERKDOCS: getHost('DOCERKDOCS') as string,
  
      DOCERMOWPS: getHost('DOCERMOWPS') as string,
  
      DOCERVCLKDOCS: getHost('DOCERVCLKDOCS') as string,
  
      DOCERWPS: getHost('DOCERWPS') as string,
  
      DOCKERMOKDOCS: getHost('DOCKERMOKDOCS') as string,
  
      DOCS: getHost('DOCS') as string,
  
      DOCSERVER: getHost('DOCSERVER') as string,
  
      DOCSK: getHost('DOCSK') as string,
  
      DRIVE: getHost('DRIVE') as string,
  
      DWEBMODOU: getHost('DWEBMODOU') as string,
  
      DYNAMICEDU: getHost('DYNAMICEDU') as string,
  
      ECIS: getHost('ECIS') as string,
  
      EDU: getHost('EDU') as string,
  
      EDUDOCS: getHost('EDUDOCS') as string,
  
      EDUKDOCS: getHost('EDUKDOCS') as string,
  
      FACE: getHost('FACE') as string,
  
      FACEAPI: getHost('FACEAPI') as string,
  
      FACEAPIWPS: getHost('FACEAPIWPS') as string,
  
      FACEWPS: getHost('FACEWPS') as string,
  
      FEEDBACKWPS: getHost('FEEDBACKWPS') as string,
  
      FILECOLLECT: getHost('FILECOLLECT') as string,
  
      FILEOPERATE: getHost('FILEOPERATE') as string,
  
      FORM: getHost('FORM') as string,
  
      FORMAPI: getHost('FORMAPI') as string,
  
      GEOACCOUNT: getHost('GEOACCOUNT') as string,
  
      HD: getHost('HD') as string,
  
      IMAGE: getHost('IMAGE') as string,
  
      IMAGEBUCKET: getHost('IMAGEBUCKET') as string,
  
      IMG: getHost('IMG') as string,
  
      JUMP: getHost('JUMP') as string,
  
      KDOC: getHost('KDOC') as string,
  
      KDOCS: getHost('KDOCS') as string,
  
      KDOCSCN: getHost('KDOCSCN') as string,
  
      KDOCSFIXED: getHost('KDOCSFIXED') as string,
  
      KDOCSOM: getHost('KDOCSOM') as string,
  
      KDOCSVCL: getHost('KDOCSVCL') as string,
  
      KOA: getHost('KOA') as string,
  
      MEETING: getHost('MEETING') as string,
  
      MOWEB: getHost('MOWEB') as string,
  
      MSGCENTER: getHost('MSGCENTER') as string,
  
      MSGEVENT: getHost('MSGEVENT') as string,
  
      NOTE: getHost('NOTE') as string,
  
      NOTEAPI: getHost('NOTEAPI') as string,
  
      OPEN: getHost('OPEN') as string,
  
      OPENAPI: getHost('OPENAPI') as string,
  
      PAN: getHost('PAN') as string,
  
      PAYAPI: getHost('PAYAPI') as string,
  
      PAYCONFIGAPI: getHost('PAYCONFIGAPI') as string,
  
      PC: getHost('PC') as string,
  
      PLUS: getHost('PLUS') as string,
  
      PLUSKDOCS: getHost('PLUSKDOCS') as string,
  
      PLUSSVR: getHost('PLUSSVR') as string,
  
      PLUSSVRDOCS: getHost('PLUSSVRDOCS') as string,
  
      PORTAL: getHost('PORTAL') as string,
  
      PRIVACYWPS: getHost('PRIVACYWPS') as string,
  
      PUB: getHost('PUB') as string,
  
      PUBKDOCS: getHost('PUBKDOCS') as string,
  
      PUBLISH: getHost('PUBLISH') as string,
  
      PUBWPS: getHost('PUBWPS') as string,
  
      RESUMEWEB: getHost('RESUMEWEB') as string,
  
      RILI: getHost('RILI') as string,
  
      RILIWPS: getHost('RILIWPS') as string,
  
      SECURITYDOC: getHost('SECURITYDOC') as string,
  
      STORE: getHost('STORE') as string,
  
      TIANCE: getHost('TIANCE') as string,
  
      TKDOCS: getHost('TKDOCS') as string,
  
      TODO: getHost('TODO') as string,
  
      TODOAPI: getHost('TODOAPI') as string,
  
      TODOKDOCS: getHost('TODOKDOCS') as string,
  
      TWPS: getHost('TWPS') as string,
  
      VAS: getHost('VAS') as string,
  
      VAS2T: getHost('VAS2T') as string,
  
      VASKDOCS: getHost('VASKDOCS') as string,
  
      VIP: getHost('VIP') as string,
  
      VIPAPI: getHost('VIPAPI') as string,
  
      VIPAPIKDOCS: getHost('VIPAPIKDOCS') as string,
  
      VIPCASHDESK: getHost('VIPCASHDESK') as string,
  
      VIPERSOPNAL: getHost('VIPERSOPNAL') as string,
  
      VIPKDOCS: getHost('VIPKDOCS') as string,
  
      WEBOFFICE: getHost('WEBOFFICE') as string,
  
      WEBOFFICEPLUGIN: getHost('WEBOFFICEPLUGIN') as string,
  
      WOA: getHost('WOA') as string,
  
      WORK: getHost('WORK') as string,
  
      WPS: getHost('WPS') as string,
  
      WPS365: getHost('WPS365') as string,
  
      WPSPAN: getHost('WPSPAN') as string,
  
      WPSPLUS: getHost('WPSPLUS') as string,
  
      WXBMC: getHost('WXBMC') as string,
  
      YUNAPI: getHost('YUNAPI') as string,
  
      YUNBIZ: getHost('YUNBIZ') as string,
  
      ZTKDOCS: getHost('ZTKDOCS') as string,
  }
  
